import CommonHelmet from '@src/components/CommonHelmet';
import TwoFactorGuard from '@src/components/guard/TwoFactorGuard';
import TwoFactorForm from '@src/features/company/auth/TwoFactorForm';
import CompanyCenterCardLayout from '@src/layouts/company/CompanyCenterCardLayout';

function CompanyTwoFactor() {
  return (
    <TwoFactorGuard isTenant={false}>
      <CompanyCenterCardLayout>
        <CommonHelmet />
        <TwoFactorForm />
      </CompanyCenterCardLayout>
    </TwoFactorGuard>
  );
}

export default CompanyTwoFactor;
